<template>
  <div class="teaser-page">
    <div class="video-container" @mouseover="showMuteIcon = true" @mouseleave="showMuteIcon = false" @click="toggleMute">
      <!-- Iframe Vimeo configurée pour lecture automatique et démarrage en sourdine pour compatibilité -->
      <div style="padding:75% 0 0 0;position:relative;">
        <iframe
          ref="vimeoPlayer"
          src="https://player.vimeo.com/video/1024426272?background=1&autoplay=1&loop=1&muted=1&controls=0"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;"
          title="teaser">
        </iframe>
      </div>

      <!-- Icône de mute/unmute au centre de la vidéo quand on survole -->
      <span v-if="showMuteIcon" class="mute-icon">
        <span class="material-icons">
          {{ isMuted ? 'volume_off' : 'volume_up' }}
        </span>
      </span>
    </div>
    <button>Support & watch the movie (coming soon)</button>
    <!-- @click="togglePaymentSlider" -->
    <transition name="slide">
      <div v-if="showPayment && checkoutUrl" id="checkout" class="checkout-container">
        <!-- Le conteneur Stripe Checkout iframe -->
        <iframe :src="checkoutUrl" frameborder="0" class="stripe-checkout-iframe"></iframe>
      </div>
    </transition>
  </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
  name: 'TeaserPage',
  data() {
    return {
      isMuted: true, // La vidéo commence en sourdine
      showMuteIcon: false,
      showPayment: false,
      checkoutUrl: '',
    };
  },
  mounted() {
    // Initialise le player Vimeo pour contrôler le volume sans HUD
    this.vimeoPlayer = new Player(this.$refs.vimeoPlayer);

    // Lorsque la vidéo est chargée, activer le son si isMuted est faux
    this.vimeoPlayer.on('loaded', () => {
      if (!this.isMuted) {
        this.vimeoPlayer.setVolume(1); // Activer le volume
      }
    });
  },
  methods: {
      async togglePaymentSlider() {
        if (!this.showPayment) {
          await this.createCheckoutSession();
          if (this.checkoutUrl) {
            this.showPayment = true;
          }
        } else {
          this.showPayment = false;
        }
      },
      toggleMute() {
        this.isMuted = !this.isMuted;
        this.vimeoPlayer.setVolume(this.isMuted ? 0 : 1); // Basculer entre sourdine et volume sans recharger la vidéo

        // Afficher l'icône de son temporairement, puis la masquer après 2 secondes
        this.showMuteIcon = true;
        setTimeout(() => {
          this.showMuteIcon = false;
        }, 1000); // 2000 ms = 2 secondes
      },
      async createCheckoutSession() {
        try {
          const response = await fetch('http://localhost:8080/create-checkout-session', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ amount: 500 }),
          });
          const responseData = await response.json();
          if (responseData.url) {
            window.location.href = responseData.url;
          } else {
            console.error("Erreur : L'URL de la session de paiement n'a pas été retournée.");
          }
        } catch (error) {
          console.error("Erreur lors de la création de la session de paiement :", error);
        }
      },
    },

};
</script>

<style scoped>
.teaser-page {
  text-align: center;
  background-color: #000;
  color: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100vw;
  overflow: hidden;
}
.video-container {
  position: relative;
  width: 80%;
  max-width: 1000px;
}
button {
  opacity: 0.5;
  margin-top: 0.5em;
  padding: 1em 2em;
  font-size: 1.2em;
  cursor: not-allowed;
  background-color: #000;
  color: #fff;
  border: 1px solid #fff;
  width: auto;
  font-family: 'Bebas Neue', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  transition: 1s;
}

/* Responsive style for the button on smaller screens */
@media (max-width: 600px) {
  button {
    padding: 0.7em 1.5em; /* Reduce padding */
    font-size: 1em; /* Smaller font size */
    margin-top: 0.3em; /* Smaller top margin */
  }
}

.mute-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.3em;
  cursor: pointer;
  transition: 0.3s;
  background-color: transparent;
}
.mute-icon .material-icons {
  font-size: 4em;
  color: #fff;
}
.mute-icon:hover .material-icons {
  color: #ddd;
}
.checkout-container {
  width: 100%;
  max-width: 600px;
  margin-top: 2em;
  transition: transform 0.3s ease;
  transform: translateY(0);
}
.stripe-checkout-iframe {
  width: 100%;
  height: 600px;
  border: none;
}
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateY(100%);
}
</style>
